import $ from "jquery";

export default function (opt) {
  var options = opt;
  var $el = $(options.el);
  var $ul;
  var is_open = false;

  function init() {
    $el.on("click", showMenu);
  }
  init();

  function bindEvents() {
    $ul.on("click", "li", onOptionClicked);
    $(document).on("click", hideMenu);
  }
  function unbindEvents() {
    $ul.off("click", "li", onOptionClicked);
    $(document).off("click", hideMenu);
  }

  function showMenu(e) {
    if (is_open) {
      hideMenu();
      return;
    }
    is_open = true;
    e.stopPropagation();
    $ul = $ul || createMenu();
    $el.append($ul);

    if (options.vpos == "top") {
      $ul.css("top", -$ul.height());
    }

    bindEvents();
    $el.addClass("active");
  }
  function hideMenu() {
    is_open = false;
    unbindEvents();
    $ul.remove();
    $el.removeClass("active");
  }

  function createMenu() {
    var ul = $("<ul></ul>").addClass("quick-menu");
    if (options.width) {
      ul.css("width", options.width);
    }
    if (options.hpos == "left") {
      var left_margin = options.width ? options.width - 20 : 160;
      ul.css("margin-left", "-" + left_margin + "px");
    }
    if (options.textAlign) {
      ul.css("text-align", options.textAlign);
    }
    if (options.marginLeft) {
      ul.css("margin-left", options.marginLeft);
    }
    for (var i = 0; i < options.options.length; i++) {
      var option = options.options[i];
      const li = $("<li></li>").text(option.label);
      ul.append(li);
    }
    return ul;
  }

  function onOptionClicked(e) {
    e.stopPropagation();
    options.options[$(e.currentTarget).index()].callback($el);
    hideMenu();
  }

  // ****************************** Public functions ******************************
  this.update = function (opt) {
    options = opt;

    if (is_open) {
      hideMenu();
    }
    if ($ul) {
      $ul.remove();
      $ul = false;
    }
  };

  return this;
}
